<template>
  <svg viewBox="0 0 80 80">
    <g>
      <g>
        <path
          fill="currentColor"
          stroke-width="0"
          d="M57.34,27.51c-.79.79-.79,2.07,0,2.86l8.64,8.64c.79.79.79,2.07,0,2.86l-8.64,8.64c-.79.79-.79,2.07,0,2.86l4.29,4.29c.79.79,2.07.79,2.86,0l15.79-15.79c.79-.79.79-2.07,0-2.86l-15.79-15.79c-.79-.79-2.07-.79-2.86,0l-4.29,4.29Z" />
        <path
          fill="currentColor"
          stroke-width="0"
          d="M50.19,60.51c-.79-.79-2.07-.79-2.86,0l-5.47,5.47c-.79.79-2.07.79-2.86,0l-24.12-24.12c-.79-.79-.79-2.07,0-2.86l24.12-24.12c.79-.79,2.07-.79,2.86,0l5.47,5.47c.79.79,2.07.79,2.86,0l4.29-4.29c.79-.79.79-2.07,0-2.86L41.86.59c-.79-.79-2.07-.79-2.86,0L.59,39.01c-.79.79-.79,2.07,0,2.86l38.41,38.41c.79.79,2.07.79,2.86,0l12.62-12.62c.79-.79.79-2.07,0-2.86l-4.29-4.29Z" />
        <path
          fill="currentColor"
          stroke-width="0"
          d="M50.54,40.44c0,5.58-4.53,10.11-10.11,10.11-5.58,0-10.11-4.53-10.11-10.11s4.53-10.11,10.11-10.11c5.58,0,10.11,4.53,10.11,10.11Z" />
      </g>
    </g>
  </svg>
</template>
